/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { NgIf, NgStyle } from '@angular/common';
import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-addons',
    template: `
		<ng-template #matPrefix>
			<span *ngIf="props.addonLeft" [ngStyle]="{ cursor: props.addonLeft.onClick ? 'pointer' : 'inherit' }" (click)="addonLeftClick($event)">
				<mat-icon *ngIf="props.addonLeft.icon">{{ props.addonLeft.icon }}</mat-icon
				><span *ngIf="props.addonLeft.text">{{ props.addonLeft.text }}</span>
			</span>
		</ng-template>

		<ng-container #fieldComponent></ng-container>

		<ng-template #matSuffix>
			<span *ngIf="props.addonRight" [ngStyle]="{ cursor: props.addonRight.onClick ? 'pointer' : 'inherit' }" (click)="addonRightClick($event)">
				<mat-icon *ngIf="props.addonRight.icon">{{ props.addonRight.icon }}</mat-icon>
				<span *ngIf="props.addonRight.text">{{ props.addonRight.text }}</span>
			</span>
		</ng-template>
	`,
    standalone: true,
    imports: [
        NgIf,
        NgStyle,
        MatIconModule,
    ],
})
export class FormlyWrapperAddonsComponent extends FieldWrapper implements AfterViewInit {
	@ViewChild('matPrefix') matPrefix: TemplateRef<any>;
	@ViewChild('matSuffix') matSuffix: TemplateRef<any>;

	ngAfterViewInit() {
		if (this.matPrefix) {
			Promise.resolve().then(() => (this.props.prefix = this.matPrefix));
		}

		if (this.matSuffix) {
			Promise.resolve().then(() => (this.props.suffix = this.matSuffix));
		}
	}

	addonRightClick($event: any): void {
		if (this.props.addonRight.onClick) {
			this.props.addonRight.onClick(this.props, this, $event);
		}
	}

	addonLeftClick($event: any): void {
		if (this.props.addonLeft.onClick) {
			this.props.addonLeft.onClick(this.props, this, $event);
		}
	}
}
